export const APIUrl = window._env_?.REACT_APP_API_BASE_URL;
